export const impulseItems = [
    '41348214',
    '60452G',
    '9656923VM000L',
    '76237105779',
    '76228523075',
    '32251582',
    '9816921VW000S',
    '41235P',
    'V04010062C002',
    '9705023VM000L',
    '9638823VM000L',
    '9819018V',
    '41235',
    '32251583',
    '9621424VM000L',
    'MTSS21028M',
    '9819218V',
    '41232075',
    '41229075GG',
    '41220097M',
    '41273141',
    '41223097P',
    'MTSS2330L',
    '60440',
    '41286075P',
    '41243052P',
    '41101075',
    '41279155G',
    '41252075G',
]